import React from 'react';

import requestAPI from '../../../helpers/requestAPI';

import { toastSuccess } from '../../../utils/toastr';
import { Button, Modal } from 'antd'

const Delete = ({ serverId }) => {

  const { confirm } = Modal;

  const sendData = React.useCallback(() => {
		const params = {
			routeParams: {
				route: 'servers',
				serverId
			},
			method: 'delete'
		};

		requestAPI(params)
    .then(response => {
      toastSuccess(response.data.ms);
    })
    .catch(error => {
      console.log(error);
    });
  }, [serverId]);
  
  const showDeleteConfirm = React.useCallback(() => {
    confirm({
      title: 'Are you sure you want to delete this server?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        sendData();
      }
    })
  }, [sendData, confirm]);

	return (
		<div className="delete">
      <Button size={'small'} type="danger" onClick={showDeleteConfirm}>Delete</Button>
		</div>
	);
};

export default Delete;
